<div class="google" id="loginRef">
  <svg class="svg-icon icon-icon">
    <use xlink:href="/assets/svg/app-extra-icons.svg#icon-google"></use>
  </svg>
  Sign in with Google
</div>
